import React from "react";
import { Link } from "react-router-dom";
import { formatDateOnly, formatCurrency, posterSrc } from "../lib/api";
import { MapPin, Calendar } from "lucide-react";

export default function EventCard({ event }) {
  const minPrice = event.tiers?.length ? Math.min(...event.tiers.map(t => t.price)) : 0;
  return (
    <Link
      to={`/events/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="group relative block overflow-hidden rounded-2xl border border-zinc-800/80 bg-[#3A1020] transition duration-300 hover:-translate-y-1 hover:rotate-[-0.5deg] hover:border-amber-500/40 hover:shadow-[0_0_40px_rgba(242,199,210,0.15)]"
    >
      {event.featured_until && new Date(event.featured_until) > new Date() && (
        <span className="absolute right-3 top-3 z-10 rounded-full bg-punch-500 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest text-white">Spotlight</span>
      )}
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={posterSrc(event.poster_url)}
          alt={event.title}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2B0B15] via-[#2B0B15]/40 to-transparent" />
        <div className="absolute left-3 top-3">
          <span className="rounded-full border border-amber-500/30 bg-[#2B0B15]/80 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-amber-400 backdrop-blur">
            {event.category}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-4">
          <h3 className="font-display text-lg font-bold uppercase leading-tight text-zinc-50 line-clamp-2">{event.title}</h3>
        </div>
      </div>
      <div className="space-y-2 p-4">
        <div className="flex items-center gap-2 text-xs text-zinc-400">
          <Calendar className="h-3.5 w-3.5 text-amber-500" />
          <span className="font-mono">{formatDateOnly(event.date)}</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-zinc-400">
          <MapPin className="h-3.5 w-3.5 text-amber-500" />
          <span className="truncate">{event.venue}, {event.city}</span>
        </div>
        <div className="flex items-center justify-between pt-2">
          <span className="text-xs text-zinc-500">From</span>
          <span className="font-mono text-sm font-bold text-amber-400">{formatCurrency(minPrice)}</span>
        </div>
      </div>
    </Link>
  );
}
